module.exports = __webpack_public_path__ + "assets/img/34_777_big.e4767a4d.jpg";